import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { TableBookingsComponent } from '../../components/table-bookings/table-bookings.component';
import { TableBookingsInstantComponent } from '../../components/table-bookings-instant/table-bookings-instant.component';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import InstantBookingService from '../../services/instant-booking.service';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularStateHelperService from '../../services/angular-state-helper.service';

@Component({
	standalone: true,
	selector: 'card-bookings-instant',
	templateUrl: './card-bookings-instant.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, TableBookingsComponent, TableBookingsInstantComponent, FormsModule ]
})
export class CardBookingsInstantComponent implements OnInit, OnDestroy {
	private instantBookingService: InstantBookingService = inject(InstantBookingService);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = 0;
		this.initBookings();
		
		// this.angularStateHelperService.scopeWM(this, 'this.vm.currentPage',
//  (nv, ov) => { if (!this.angularHelperService.equals(nv, ov) && ov < nv) loadBookings(); }); 
// TODO ANGULAR_2: shold here be a fnc called loadBookings?
		
//		this.angularStateHelperService.scopeWF(this, this.instantBookingService.isAvailable, (isAvailable) => {
//			this.vm.isAvailable = isAvailable;
//			if (isAvailable) {
//				this.initBookings();
//			} else {
//				this.handleBookingsUpdateDestroy();
//			}
//		});
		this.vm.statusCheckInterval = this.angularHelperService.createInterval(() => {
			var newAvailableStatus = this.instantBookingService.isAvailable();
			if (this.vm.isAvailable != newAvailableStatus) {
				this.vm.isAvailable = newAvailableStatus;
				if (newAvailableStatus) {
					this.initBookings();
				} else {
					this.handleBookingsUpdateDestroy();
					this.vm.loading = false;
				}
			}
		}, 200);
		
		this.vm.toggleAvailabilityStatus = this.toggleStatus;
	};
	
	ngOnDestroy() {
		if (this.vm.statusCheckInterval) {
			this.angularHelperService.cancelInterval(this.vm.statusCheckInterval);
		}
		this.handleBookingsUpdateDestroy();
	};
	
	toggleStatus = (newStatus: boolean): void => {
		this.vm.loading = true;
		this.instantBookingService.toggleAvailabilityStatus(newStatus);
	}
	
	initBookings() {
		this.vm.loading = true;
		this.getBookings();
		this.handleBookingsUpdateInit();
	}
	
	getBookings() {
		this.vm.bookings = this.instantBookingService.getRequests();
		this.angularHelperService.createTimer(
			() => {
				this.vm.loading = (typeof this.vm.bookings === 'undefined' && this.vm.isAvailable);
			}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY
		);
	}
	
	handleBookingsUpdateInit() {
		this.handleBookingsUpdateDestroy();
		if (!this.vm.isAvailable) return;
		
		this.vm.timerInterval = this.angularHelperService.createInterval(() => { this.getBookings(); }, 1000);
	}
	
	handleBookingsUpdateDestroy() {
		if (this.vm.timerInterval) this.angularHelperService.cancelInterval(this.vm.timerInterval);
	}
	
}